<template>
	<div
		v-if="title || elements.length"
		:id="$vnode.key"
		:class="[
			'c-block-list-borger-dk-custom',
			'w-5col >=768:w-8col max-w-full mx-auto',
		]"
	>
		<LongReadTarget
			v-if="title && includeInToc"
			:container-id="$vnode.key"
			:title="title"
		/>

		<div
			v-if="elements && elements.length"
			class="font-darker-grotesque text-label-card font-semibold mb-2xs"
			v-text="'Dette indhold kommer fra borger.dk'"
		></div>

		<AccordionLayout v-bind="{ title, elements }">
			<template #title>
				<BaseH2
					v-if="title"
					tag="h2"
					class="text-primary-button"
					v-text="title"
				/>
			</template>

			<template #header="{ item }">
				<BaseH4 tag="h3" class="font-semibold" v-text="item.title" />
			</template>

			<template #panel="{ item }">
				<span
					class="s-rich-text s-rich-text--monotone"
					v-html="item.content"
				></span>
			</template>
		</AccordionLayout>
	</div>
</template>

<script>
import AccordionLayout from '~/components/shared/AccordionLayout';
import LongReadTarget from '~/citi-baseline/components/LongRead/LongReadTarget';

export default {
	name: 'BlockListBorgerdkCustom',
	components: { AccordionLayout, LongReadTarget },
	inheritAttrs: false,
	props: {
		title: {
			type: String,
			required: false,
		},

		includeInToc: {
			type: Boolean,
			required: false,
		},

		informationcontainer: {
			type: Object,
			default: () => {},
		},
	},

	computed: {
		elements() {
			if (this.informationcontainer?.elements) {
				const { elements: el } = this.informationcontainer;
				const unflattenedResponse = el.map((item) => {
					return item.microArticles || item;
				});

				const response = [];
				unflattenedResponse.forEach((e) => {
					!Array.isArray(e) && response.push(e);
					Array.isArray(e) &&
						e.forEach((item) => response.push(item));
				});

				return response;
			}

			return [];
		},
	},
};
</script>
